import { memo } from 'react';
import { IProfileInfoTemplate } from '../../interfaces/components/index.interface';
import { RoleViewEnum } from '../../interfaces/profile.interface';
import ProfileInfoAddButton from '../elements/profile/button/ProfileInfoAddButton';
import ProfileInfoTitle from '../elements/profile/title/ProfileInfoTitle';

const ProfileInfoTemplate: React.FC<IProfileInfoTemplate> = ({
  initData,
  DetailProfileInfoFC,
  roleView,
  setModal,
  title,
  addButonContent,
  modalName,
  intro = false,
  introContent,
}) => {
  return (
    <>
      <ProfileInfoTitle title={title} />
      {intro &&
        roleView === RoleViewEnum.Owner &&
        initData &&
        initData.length === 0 && (
          <p className=" font-medium text-sm text-black">{introContent}</p>
        )}
      <div className="flex flex-col gap-3">
        {initData.length > 0
          ? initData.map((item: any) => {
              return (
                <>
                  <DetailProfileInfoFC
                    data={item}
                    setModal={setModal}
                    roleView={roleView}
                  />
                </>
              );
            })
          : roleView !== RoleViewEnum.Owner && (
              <span
                className={`text-[14px] font-[400] leading-[24px] flex-1 break-words text-gray-500`}
              >
                Chưa cập nhật
              </span>
            )}
      </div>
      <ProfileInfoAddButton
        roleView={roleView}
        modalName={modalName}
        content={addButonContent}
        setModal={setModal}
      />
    </>
  );
};

export default memo(ProfileInfoTemplate);
